import React, { useState, useEffect } from "react";
import "./ExecutiveBoard.css";

/**
 * Add or update members in the `members` array.
 * Images should live under /public/images/executive/... or served from an absolute URL.
 */
const members = [
  {
    img: "/images/board/Sarpanch1.jpg",
    name: "Mr. Pravin Dashrath Dongare",
    position: "Sarpanch",
    bio:
      "Serving as the Sarpanch of Nimgoan Ketki with a focus on infrastructure and community welfare.",
  },
  {
    img: "/images/board/manisha.jpg",
    name: "Mrs. Manisha Suresh Barawkar",
    position: "Upa-Sarpanch",
    bio:
      "Leads women's empowerment initiatives and education programs across the village.",
  },
  {
    img: "/images/board/gramsevak.jpg",
    name: "Mr. L.K. Jagtap",
    position: "Village Development Officer",
    bio:
      "Responsible for implementing development schemes with emphasis on agriculture and public services.",
  },
  {
    img: "/images/board/ajit.jpg",
    name: "Mr. Ajitrav Bhiva Misal",
    position: "Member",
    bio: "Mr. Ajitrav Bhiva Misal is a dedicated member of the Executive Board, committed to agriculture development and improving irrigation facilities. His focus is on enhancing farmers' welfare and promoting sustainable agricultural practices."
  },
  {
    img: "/images/board/anuradha.jpg",
    name: "Mrs. Anuradha Santosh Jagtap",
    position: "Member",
    bio: "Mrs. Anuradha Santosh Jagtap works actively toward advancing education and women’s empowerment. She organizes educational workshops and supports local self-help groups."
  },
  {
    img: "/images/board/dadaram.jpg",
    name: "Mr. Dadaram Vitthal Shende",
    position: "Member",
    bio: "Mr. Dadaram Vitthal Shende is dedicated to improving sanitation and healthcare services in the village. He participates in health camps and cleanliness drives regularly."
  },
  {
    img: "/images/board/mina.jpg",
    name: "Mrs. Mina Dipak Bhong",
    position: "Member",
    bio: "Mrs. Mina Dipak Bhong works on community welfare and child development programs. She promotes early childhood education and welfare initiatives in the village."
  },
  {
    img: "/images/board/sachin-chandane.jpg",
    name: "Mr. Sachin Dattatray Chandane",
    position: "Member",
    bio: "Mr. Sachin Dattatray Chandane focuses on infrastructure development, including road projects and improving water supply systems in the village."
  },
  {
    img: "/images/board/tatyasaheb.jpg",
    name: "Mr. Tatayasheb Bapu Wadapure",
    position: "Member",
    bio: "Mr. Tatayasheb Bapu Wadapure contributes to environmental conservation. He leads plantation drives and waste-management initiatives to create a cleaner and greener community."
  },
  {
    img: "/images/board/rina.jpg",
    name: "Mrs. Rina Subhash Bhong",
    position: "Member",
    bio: "Mrs. Rina Subhash Bhong works for social welfare and upliftment of underprivileged families. She is involved in initiatives that offer financial and social support."
  },
  {
    img: "/images/board/sachin.jpg",
    name: "Mr. Sachin Ankush Jadhav",
    position: "Member",
    bio: "Mr. Sachin Ankush Jadhav engages youth through sports and vocational training programs, helping them develop essential life skills."
  },
  {
    img: "/images/board/lata.jpg",
    name: "Mrs. Lata Hanumant Raut",
    position: "Member",
    bio: "Mrs. Lata Hanumant Raut works toward improving healthcare access. She organizes medical camps and health awareness programs."
  },
  {
    img: "/images/board/archana.jpg",
    name: "Mrs. Archana Anil Bhong",
    position: "Member",
    bio: "Mrs. Archana Anil Bhong promotes women's rights and rural entrepreneurship. She conducts training programs to help women become financially independent."
  },
  {
    img: "/images/board/alka.jpg",
    name: "Mrs. Alka Manik Bhong",
    position: "Member",
    bio: "Mrs. Alka Manik Bhong works to improve educational facilities and promotes adult literacy, aiming to ensure access to quality education."
  },
  {
    img: "/images/board/sayali.jpg",
    name: "Mrs. Sayali Sagar Misaal",
    position: "Member",
    bio: "Mrs. Sayali Sagar Misaal focuses on child and maternal health. She organizes health awareness programs designed to support women and children."
  },
  {
    img: "/images/board/amol.jpg",
    name: "Mr. Amol Popat Hegde",
    position: "Member",
    bio: "Mr. Amol Popat Hegde is dedicated to infrastructure and sanitation improvements. His work includes improving public facilities and waste-management systems."
  },
  {
    img: "/images/board/madhukar.jpg",
    name: "Mr. Madhukar Hariba Bhosale",
    position: "Member",
    bio: "Mr. Madhukar Hariba Bhosale works closely with farmers, introducing modern agricultural practices to improve crop yields and sustainability."
  },
  {
    img: "/images/board/kamal.jpg",
    name: "Mrs. Kamal Shankar Raut",
    position: "Member",
    bio: "Mrs. Kamal Shankar Raut focuses on rural development, especially housing and basic amenities. She works to improve living conditions in the village."
  },
  {
    img: "/images/board/vaibhav.jpg",
    name: "Mr. Vaibhav Jyotiram Aadling",
    position: "Clerk",
    bio: "Mr. Vaibhav Jyotiram Aadling manages administrative operations, ensuring smooth documentation and execution of daily Gram Panchayat functions."
  },
  {
    img: "/images/board/kastura.jpg",
    name: "Miss. Kastura Ramadas Barawkar",
    position: "Clerk",
    bio: "Miss. Kastura Ramadas Barawkar assists in administrative tasks, documentation, and record-keeping for the Executive Board."
  }
  // add more members here as objects
];

const ExecutiveBoard = () => {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const openLightbox = (index) => setLightboxIndex(index);
  const closeLightbox = () => setLightboxIndex(null);

  const goNext = (e) => {
    e?.stopPropagation();
    setLightboxIndex((prev) =>
      prev === null ? 0 : (prev + 1) % members.length
    );
  };
  const goPrev = (e) => {
    e?.stopPropagation();
    setLightboxIndex((prev) =>
      prev === null ? 0 : (prev - 1 + members.length) % members.length
    );
  };

  // Keyboard support for lightbox (Escape, ArrowLeft, ArrowRight)
  useEffect(() => {
    function handleKey(e) {
      if (lightboxIndex === null) return;
      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowRight") goNext();
      if (e.key === "ArrowLeft") goPrev();
    }
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lightboxIndex]);

  return (
    <div className="eb-wrapper">
      <header className="eb-header" role="banner">
        <div className="eb-header-inner">
          <img
            src="/images/logobg.png"
            alt="Nimgaon Ketki Gram Panchayat"
            className="eb-logo"
          />
          <div className="eb-title-wrap">
            <h1 className="eb-title">Executive Board</h1>
            <p className="eb-sub">Nimgaon Ketki Gram Panchayat</p>
          </div>
        </div>
      </header>

      <main className="eb-main" id="main-content" role="main">
        <section className="eb-intro card">
          <h2>Introduction</h2>
          <p>
            The Executive Board manages governance, development and public
            services for Nimgaon Ketki. Below are the elected and appointed
            members who serve the community.
          </p>
        </section>

        <section className="eb-members">
          <h2 className="section-title">Members</h2>

          <div className="members-grid">
            {members.map((m, i) => (
              <article className="member-card" key={i}>
                <button
                  className="member-photo-btn"
                  aria-label={`Open photo of ${m.name}`}
                  onClick={() => openLightbox(i)}
                >
                  <img
                    src={m.img}
                    alt={`${m.name} — ${m.position}`}
                    className="member-photo"
                    loading="lazy"
                  />
                </button>

                <div className="member-body">
                  <h3 className="member-name">{m.name}</h3>
                  <p className="member-position">{m.position}</p>
                  <p className="member-bio">{m.bio}</p>
                </div>
              </article>
            ))}
          </div>
        </section>

        
      </main>

      {/* Lightbox overlay */}
      {lightboxIndex !== null && (
        <div
          className="eb-lightbox"
          role="dialog"
          aria-modal="true"
          aria-label={`Image viewer ${lightboxIndex + 1}`}
          onClick={closeLightbox}
        >
          <div
            className="eb-lightbox-inner"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="eb-lightbox-close"
              aria-label="Close image"
              onClick={closeLightbox}
            >
              ×
            </button>

            <div className="eb-lightbox-media">
              <button
                className="eb-nav eb-prev"
                aria-label="Previous image"
                onClick={goPrev}
              >
                ‹
              </button>

              <img
                src={members[lightboxIndex % members.length].img}
                alt={`${members[lightboxIndex].name}`}
                className="eb-lightbox-img"
              />

              <button
                className="eb-nav eb-next"
                aria-label="Next image"
                onClick={goNext}
              >
                ›
              </button>
            </div>

            <div className="eb-lightbox-caption">
              <strong>{members[lightboxIndex].name}</strong>
              <div className="caption-pos">{members[lightboxIndex].position}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExecutiveBoard;
